import { ArrowLink, Section, SectionHeader } from '@/components/ui/primitives';
import { TeacherCard, TeacherCardSkeleton } from '@/components/teachers/TeacherCard';
import { useTeachers } from '@/lib/queries';
import { useI18n } from '@/lib/i18n';

export function FeaturedTeachers(): React.JSX.Element {
  const { t } = useI18n();
  const { data, isPending } = useTeachers({ perPage: 3, sort: 'availability' });

  return (
    <Section>
      <SectionHeader
        overline={t('teachers.overline')}
        title={t('teachers.title')}
        action={<ArrowLink to="/teachers">{t('teachers.viewAll')}</ArrowLink>}
      />

      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {isPending
          ? Array.from({ length: 3 }, (_, i) => <TeacherCardSkeleton key={i} />)
          : data?.items.map((teacher) => <TeacherCard key={teacher.id} teacher={teacher} />)}
      </div>
    </Section>
  );
}
